import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';

export default function PaymentPageTabNavigation() {
  const pageTabs: PageTabItem[] = [
    {
      label: 'invoice:payment.tabs.incomingBankPayments',
      route: RoutesEnum.PaymentTransactions,
    },
    {
      label: 'invoice:payment.tabs.paymentAccounting',
      route: RoutesEnum.PaymentAccounting,
    },
  ];

  return <PageTabNavigation pageTabs={pageTabs} />;
}
